<template>
	<div>
		<div class="pdfWrapper">
			<pdfViewer :selectedFile="fileToView" :isOriginalFile="true" />
		</div>
	</div>
</template>

<script>
import pdfViewer from '@/components/pdfViewer';
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
export default {
	created() {},
	components: {
		pdfViewer,
	},
	data() {
		return {};
	},
	methods: {},
	computed: {},
	mounted() {},
	props: {
		fileToView: {
			type: Object,
			default: null,
			required: true,
		},
	},
};
</script>

<style lang="scss" scoped>
.pdfWrapper {
	display: flex;
	flex-direction: column;
	width: 100%;
	align-items: center;
}
</style>
